import * as d3 from 'd3'

export default {
  methods: {

    draw_ChartCanvas(list) {
      let main = this.title.main
      let sub = this.title.sub

      let canvas = this.canvasChart
      .append('g')
      .attr('id', `CHART_${list.id}_${this.localId}`)
      .attr('transform', `translate(${list.x +.5}, ${list.y + .5})`)

      canvas
      .append('text')
      .attr('x', main.x) .attr('y', main.y + main.tSize*0.75)
      .style('font-size', main.tSize)
      .style('fill', main.tColor)
      .attr('text-anchor', main.align)
      .text(()=> {
        if(main.name == 'GROUP') return list.name; else return main.name
      })

      canvas
      .append('text')
      .attr('x', sub.x) .attr('y', sub.y + sub.tSize*0.75)
      .style('font-size', sub.tSize)
      .style('fill', sub.tColor)
      .attr('text-anchor', sub.align)
      .text(()=> {
        if(sub.name == 'GROUP') return list.name; else return sub.name
      })

      this.draw_ChartAxis(list)
      if(this.legends.visible == 'Y') this.draw_Legends(list)
      this.draw_Grid(list)
    },

    
    draw_ChartAxis(list) {
      
      let axis = d3.select(`#CHART_${list.id}_${this.localId}`)
      .append('g')
      .attr('id', `AXIS_${list.id}_${this.localId}`)
      .attr('transform', `translate(${0}, ${this.chart.y})`)

      axis
      .append('line')
      .attr('x1', 0).attr('x2', 0).attr('y1', 0).attr('y2', this.chart.height)
      .attr('stroke', '#757575').attr('stroke-width', .5).attr('opacity', 1)

      axis
      .append('line')
      .attr('x1', 0).attr('x2', this.chart.width).attr('y1', this.chart.height).attr('y2', this.chart.height)
      .attr('stroke', '#757575').attr('stroke-width', .5).attr('opacity', 1)

      axis
      .append('line')
      .attr('x1', this.chart.width).attr('x2', this.chart.width).attr('y1', 0).attr('y2', this.chart.height)
      .attr('stroke', '#757575' ).attr('stroke-width', .5).attr('opacity', 1)

      axis // Primary Axis
      .append('text')
      .attr('transform', `translate(${this.primary.titleX}, ${this.chart.height/2 + this.primary.tSize*0.4}) rotate(-90)`)
      .attr('font-size', this.primary.tSize).attr('fill', this.primary.tColor)
      .attr('text-anchor', 'middle')
      .text(this.primary.title)

      axis // secondary Axis
      .append('text')
      .attr('transform', `translate(${this.secondary.titleX}, ${this.chart.height/2 + this.secondary.tSize*0.4}) rotate(-90)`)
      .attr('font-size', this.secondary.tSize).attr('fill', this.secondary.tColor)
      .attr('text-anchor', 'middle')
      .text(this.secondary.title)
    },


    draw_Legends(list) {
      let item = d3.select(`#CHART_${list.id}_${this.localId}`)
      .append('g')
      .attr('id', `LEGEND_GROUP_${list.id}_${this.localId}`)
      .attr('transform', `translate(${0}, ${this.legends.y})`)
      
      let x_ = 0
      this.chart.styles.forEach((d,i)=> {
        item
        .append('rect')
        .attr('id', `ICON_${i}_${this.localId}`)
        .attr('x', x_)
        .attr('y', (d.type=='LINE') ? 3 : 0)
        .attr('width', 6)
        .attr('height', (d.type=='LINE') ? 1 : 6)
        .attr('fill', d.color).attr('stroke', d.color)

        item
        .append('text')
        .attr('id', `ITEM_${list.id}_${i}_${this.localId}`)
        .attr('transform', `translate(${x_ + 10}, ${3 + this.legends.name.tSize*0.36})`)
        .attr('font-size', this.legends.name.tSize).attr('fill', this.legends.name.tColor)
        .text(d.name)

        x_ = x_ + this.getNode(`#ITEM_${list.id}_${i}_${this.localId}`, 'width') + 20
      })

      let len = this.getNode(`#LEGEND_GROUP_${list.id}_${this.localId}`, 'width')
      if(this.legends.align == 'center') {
        d3.select(`#LEGEND_GROUP_${list.id}_${this.localId}`)
        .attr('transform', `translate(${(this.chart.width/2) - (len/2)}, ${this.legends.y})`)
      }
      if(this.legends.align == 'right') {
        d3.select(`#LEGEND_GROUP_${list.id}_${this.localId}`)
        .attr('transform', `translate(${this.chart.width - len - 1}, ${this.legends.y})`)
      }
    },


    draw_Grid(list) {
      let tick = this.chart.height / 5

      let grids = d3.select(`#CHART_${list.id}_${this.localId}`)
      .append('g')
      .attr('id', `AXIS_${list.id}_${this.localId}`)
      .attr('transform', `translate(${0}, ${this.chart.y})`)

      for(let i=0; i<6; i++) {
        grids // Grid
        .append('line')
        .attr('x1', 0).attr('x2', this.chart.width)
        .attr('y1', tick * i).attr('y2', tick * i)
        .attr('stroke', '#bcbcbc').attr('stroke-width', .5)
        .attr('opacity', .5)

        grids // Primary Axis
        .append('text')
        .attr('x', (this.primary.position == 'left') ? -2 : this.chart.width + 2)
        .attr('y', this.chart.height - (tick * i) + 3)  
        .attr('font-size', 9).attr('fill', '#757575')
        .attr('text-anchor', (this.primary.position == 'left') ? 'end': 'start')
        .text(()=> {
          let value = (this.primary.max * (i*.2)).toFixed(0)
          if(this.primary.unit.toLowerCase() == 'k') value = (value/1000).toFixed(1)
          return value + this.primary.unit
        })

        grids // secondary Axis
        .append('text')
        .attr('x', (this.secondary.position == 'left') ? -2 : this.chart.width + 2)
        .attr('y', this.chart.height - (tick * i) + 3)
        .attr('font-size', 9).attr('fill', '#757575')
        .attr('text-anchor', (this.secondary.position == 'left') ? 'end': 'start')
        .text( ()=> {
          let value = (this.secondary.max * (i*.2)).toFixed(0)
          if(this.secondary.unit.toLowerCase() == 'k') value = (value/1000).toFixed(1)
          return value + this.secondary.unit
        })
      }
    },


  }
}